import { FormControlLabel, styled, Switch } from '@mui/material';

export const SwitchStyles = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.secondary.dark,
  },
  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.secondary.dark,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.secondary.dark,
  },
  '& .Mui-checked .MuiSwitch-thumb': {
    backgroundColor: theme.palette.details.main,
  },
}));

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: 0,
}));
